import React, { useState, useEffect } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";

const AttendanceEmployeeFilter = ({ onFilterChange, initialFilters }) => {
  const [selectedDate, setSelectedDate] = useState(
    initialFilters?.date ? new Date(initialFilters.date) : null
  );
  const [selectedMonth, setSelectedMonth] = useState(
    initialFilters?.month || null
  );
  const [selectedYear, setSelectedYear] = useState(
    initialFilters?.year || null
  );

  // Month options
  const monthOptions = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  // Generate year options (current year and 3 years back)
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 4 }, (_, i) => ({
    value: currentYear - i,
    label: (currentYear - i).toString(),
  }));

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#008a42" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#008a42",
      },
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#008a42" : provided.borderColor,
      boxShadow: state.isFocused ? "0 0 0 1px #008a42" : provided.boxShadow,
      "&:hover": {
        borderColor: "#008a42",
      },
    }),
  };

  const handleSearch = () => {
    let startDate, endDate;

    if (selectedDate) {
      // If specific date is selected, use that date
      startDate = dayjs(selectedDate).format("YYYY-MM-DD");
      endDate = dayjs(selectedDate).format("YYYY-MM-DD");
    } else if (selectedMonth && selectedYear) {
      // If month and year are selected, use the entire month
      const monthStart = dayjs()
        .year(selectedYear.value)
        .month(selectedMonth.value - 1)
        .startOf("month");
      const monthEnd = dayjs()
        .year(selectedYear.value)
        .month(selectedMonth.value - 1)
        .endOf("month");
      startDate = monthStart.format("YYYY-MM-DD");
      endDate = monthEnd.format("YYYY-MM-DD");
    } else if (selectedYear) {
      // If only year is selected, use current month of that year
      const monthStart = dayjs()
        .year(selectedYear.value)
        .month(new Date().getMonth())
        .startOf("month");
      const monthEnd = dayjs()
        .year(selectedYear.value)
        .month(new Date().getMonth())
        .endOf("month");
      startDate = monthStart.format("YYYY-MM-DD");
      endDate = monthEnd.format("YYYY-MM-DD");
    } else {
      // Default to current month
      startDate = dayjs().startOf("month").format("YYYY-MM-DD");
      endDate = dayjs().format("YYYY-MM-DD");
    }

    onFilterChange({
      start_date: startDate,
      end_date: endDate,
      date: selectedDate,
      month: selectedMonth,
      year: selectedYear,
    });
  };

  const handleClear = () => {
    setSelectedDate(null);
    setSelectedMonth(null);
    setSelectedYear(null);

    // Reset to current month
    const startDate = dayjs().startOf("month").format("YYYY-MM-DD");
    const endDate = dayjs().format("YYYY-MM-DD");

    onFilterChange({
      start_date: startDate,
      end_date: endDate,
      date: null,
      month: null,
      year: null,
    });
  };

  return (
    <>
      {/* Search Filter */}
      <div className="row filter-row mb-3">
        <div className="col-sm-6 col-md-2">
          <div className="input-block mb-3 form-focus select-focus">
            <div className="cal-icon">
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                className="form-control floating datetimepicker"
                dateFormat="dd-MM-yyyy"
                placeholderText="Select specific date"
                isClearable
              />
            </div>
            <label className="focus-label">Date</label>
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <div className="input-block mb-3 form-focus select-focus">
            <Select
              value={selectedMonth}
              onChange={(option) => setSelectedMonth(option)}
              options={monthOptions}
              placeholder="Select Month"
              styles={customStyles}
              isClearable
            />
            <label className="focus-label">Select Month</label>
          </div>
        </div>
        <div className="col-sm-6 col-md-2">
          <div className="input-block mb-3 form-focus select-focus">
            <Select
              value={selectedYear}
              onChange={(option) => setSelectedYear(option)}
              options={yearOptions}
              placeholder="Select Year"
              styles={customStyles}
              isClearable
            />
            <label className="focus-label">Select Year</label>
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <button
            onClick={handleSearch}
            className="btn btn-success btn-block w-100"
          >
            <i className="fa fa-search me-2" />
            Search
          </button>
        </div>
        <div className="col-sm-6 col-md-2">
          <button
            onClick={handleClear}
            className="btn btn-outline-secondary btn-block w-100"
          >
            <i className="fa fa-times me-2" />
            Clear
          </button>
        </div>
      </div>
      {/* /Search Filter */}
    </>
  );
};

export default AttendanceEmployeeFilter;
